// Copyright (c) 2021-2022 Uber Technologies Inc.
//
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

export const WORKFLOW_LIST_FETCH_WORKFLOW_LIST_URL = 'WORKFLOW_LIST_FETCH_WORKFLOW_LIST_URL';
export const WORKFLOW_LIST_FILTER_BY = 'WORKFLOW_LIST_FILTER_BY';
export const WORKFLOW_LIST_FILTER_MODE = 'WORKFLOW_LIST_FILTER_MODE';
export const WORKFLOW_LIST_FILTER_MODE_BUTTON_LABEL = 'WORKFLOW_LIST_FILTER_MODE_BUTTON_LABEL';
export const WORKFLOW_LIST_IS_CRON = 'WORKFLOW_LIST_IS_CRON';
export const WORKFLOW_LIST_QUERY_STRING = 'WORKFLOW_LIST_QUERY_STRING';
export const WORKFLOW_LIST_STATE = 'WORKFLOW_LIST_STATE';
export const WORKFLOW_LIST_STATUS = 'WORKFLOW_LIST_STATUS';
export const WORKFLOW_LIST_STATUS_NAME = 'WORKFLOW_LIST_STATUS_NAME';
export const WORKFLOW_LIST_WORKFLOW_ID = 'WORKFLOW_LIST_WORKFLOW_ID';
export const WORKFLOW_LIST_WORKFLOW_NAME = 'WORKFLOW_LIST_WORKFLOW_NAME';
